import { render } from "./EarthquakeControllPanel.vue?vue&type=template&id=2116297c&ts=true"
import script from "./EarthquakeControllPanel.vue?vue&type=script&lang=ts"
export * from "./EarthquakeControllPanel.vue?vue&type=script&lang=ts"

import "./EarthquakeControllPanel.vue?vue&type=style&index=0&id=2116297c&lang=sass"

import exportComponent from "/home/ec2-user/environment/test_front_adachi/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__